import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "right" }

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import Top from "@/components/Top.vue";
import DeptApi from "@/api/DeptApi";

interface Tree {
  id: string;
  parentId: string;
  label: string;
  count: number;
  children?: Tree[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const defaultProps = {
  children: "children",
  label: "label",
};

const handleNodeClick = (data: Tree) => {
  if (data.children?.length === 0) {
    router.push("/index/dept/" + data.id);
  }
};

const tree = ref<Array<Tree>>([]);
DeptApi.list().then((res) => {
  tree.value.splice(0, tree.value.length);
  res.data.forEach((item: any) => {
    tree.value.push(item);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "text" }, "组织", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tree, {
            "default-expand-all": true,
            data: tree.value,
            props: defaultProps,
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Top),
      (_openBlock(), _createBlock(_component_router_view, {
        class: "content",
        key: _unref(route).params.id
      }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      }))
    ])
  ]))
}
}

})